export const styles = {
	StackContainer: {
		minHeight: '100%',
		height: '100%',
	},
	ProgressContainer: {
		display: 'flex',
		width: '100%',
		height: '40vh',
		justifyContent: 'center',
		alignItems: 'center',
	},
	CallToActionBox: {
		margin: '1rem',
	},
	CircularProgressIcon: {
		color: 'secondary.main',
		size: '2.8rem',
	},
	ContentBox: {
		flexGrow: 1,
	},
	ContentContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: '100%',
	},
	GamesGrid: {
		padding: { lg: '3.2rem 9.8rem', xs: '3.2rem' },
	},
	GameGridItem: {
		paddingLeft: '0',
		gap: '1rem',
	},
	Divider: {
		color: 'secondary.main',
		mx: 4,
	},
	Divider2: {
		color: 'primary.main',
		mx: { lg: 40, md: '3.2rem', sm: '3.2rem', xs: '3.2rem' },
		borderBotttomWidth: 'thick',
	},
	FilterRowGrid: {
		pb: 2,
		pt: 4,
		width: '100%',
	},
	MobileCreateButtonBox: {
		// display: { xs: 'flex', sm: 'flex' },
		alignItems: 'center',
		marginBottom: '2rem',
		justifyContent: 'flex-end',
		width: '100%',
	},
}
